module.exports = __webpack_public_path__ + "static/media/bg.e0c90774.png";